import React from 'react';
import styles from './drawer-handle.module.scss';
import { buildClassName } from 'utils/build-class-name';

export interface DrawerHandleProps {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
  borderRadius?: number;
}

/**
 * DrawerHandle - A symbol for draggable drawers
 * 
 * It indicates that the drawer can be dragged.
 * 
 * @example
 * ```tsx
 * <DrawerHandle />
 * <DrawerHandle color="#007AFF" width={60} height={6} />
 * ```
 */
export function DrawerHandle({
  className,
  color = 'rgba(0, 0, 0, 0.2)',
  width = 40,
  height = 4,
  borderRadius = 2,
}: DrawerHandleProps) {
  return (
    <div
      className={buildClassName(styles.handle, className)}
      style={{
        backgroundColor: color,
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: `${borderRadius}px`,
      }}
      aria-hidden="true"
      role="presentation"
    />
  );
}
